import IconSign from "../../../public/images/sign.svg";
import EditorPanelButton from "../buttons/EditorPanelButton";
import {useTranslation} from "next-i18next";
import Select from "./Select";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import {useCallback} from "react";
import PropTypes from "prop-types";

const SignSelect = ({signatures}) => {
  const store = useEditorPanelButtonStore();
  const {t} = useTranslation();

  const handleAddSignatureClick = useCallback(() => {
    store.setIsSignatureModalOpen(true);
  }, [store.setIsSignatureModalOpen]);

  const buttonContent = <div className="select__button-text">
    <IconSign className="select__icon"/>
    <span>{t(`convert-and-edit:editor.sign`)}</span>
  </div>

  return (
    <Select tab='sign' buttonContent={buttonContent}>
      <div className={`sign-select__block ${store.isOpenModal !== 'sign' ? "select__list-hide" : ""}`}>
        <ul className="sign-select__list">
          {signatures}
        </ul>
        <EditorPanelButton text="new-sign" onClick={handleAddSignatureClick} id="signButton"/>
      </div>
    </Select>
  );
};

SignSelect.propTypes = {
  signatures: PropTypes.array,
};

export default SignSelect;
